import script from "./UserLimits.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserLimits.vue?vue&type=script&setup=true&lang=ts"

import "./UserLimits.vue?vue&type=style&index=0&id=f44fe474&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f44fe474"]])

export default __exports__